<template>
	<div class="ewm1">
		<div class="img" :id="'imgUrl'+index">
			<vue-qr class='fukuanBox' style="display: inline-block;width: 34%;" :logoSrc="imagePath" :text="payImg" :size="500"></vue-qr>
			<!-- <p v-if="fxyc != 'fxyc'">快捷购买二维码</p>
      <p v-else>预存购买二维码</p> -->
      <!-- <div style="width:100%;height: 48px;background: #F7F9FA;border-radius: 0px 0px 2px 2px;border: 1px solid #E9E9E9;position: absolute;left: 0px;bottom: 0px;width: 100%;"> -->
           <!-- <div style="height: 100%;display: inline-block;width: 31.5%;line-height:46px;font-size: 14px;color:#00ABFA" @click="downloadFile(index)">二维码下载</div> -->
           <!-- <div style="width:1px;height:15px;background-color:#E8E8E8;display: inline-block;"></div>
           <div style="height: 100%;display: inline-block;width: 31.5%;line-height:46px;font-size: 14px;">营销素材获取</div>
           <div style="width:1px;height:15px;background-color:#E8E8E8;display: inline-block;"></div>
           <div style="height: 100%;display: inline-block;width: 31.5%;line-height:46px;font-size: 14px;">签约管理</div> -->
      <!-- </div> -->
			<div class="downloadBox" :style="{ width: downloadBoxWidth }">
				<template v-if="!preOrder">
				<span style="color: rgb(153, 153, 153);">{{ $t('sale.commodity.channelSelect') }}</span>
				<el-select  class='select'   v-model="subChannelId1" :placeholder="$t('sale.commodity.select')" size="mini" @change='changeImgFun()'>
					<el-option v-for="item in channelData" :key="item.id" :label="$tChannel(item.name)" :value="item.id"></el-option>
				</el-select>
				</template>
				<a class="blue" @click="downloadFile(index)">{{ $t('sale.commodity.downloadQr') }}</a>
			</div>
		</div>
	</div>
</template>

<script>
	import vueQr from 'vue-qr'
	export default {
		data() {
			return {
				subChannelId1:'',
				payImg:'',
                fxyc1:''
			}
		},
		props:[
			'index',
			'imagePath',
			'subChannelId',
			'channelData',
			'channelId',
			'id',
			'channelName',
			'type',
			'hebing',
			'group',
			'productGroup',
			'fxyc',
			'productCode',
			'preOrder', // 不记名核销标识
			'billingId', // 账单ID
			'entityCard' // 实体卡销售标识
		],
		mounted() {
			this.subChannelId1=this.subChannelId;
			this.fxyc = this.fxyc
			console.log(this.fxyc)
			this.changeImgFun()
		},
		computed: {
			/**
			 * sale/commodity 为 62%，其他页面为 60%
			 * @returns {string}
			 */
			downloadBoxWidth() {
				const path = (this.$route && this.$route.path) || ''
				return path.indexOf('/sale/commodity') === 0 ? '62%' : '60%'
			}
		},
		watch:{
			subChannelId(){
				this.subChannelId1=this.subChannelId;
        		this.changeImgFun()
			},
			entityCard(){
				this.changeImgFun()
			},
			productGroup(){
				this.changeImgFun()
			}
		},
		methods: {
			changeImgFun(){
				// 实体卡销售：healthManagement 链接
				if(this.entityCard) {
					this.payImg = `https://api.dajiuxing.com.cn/djxh5/#/healthManagement?subChannelId=${this.subChannelId1}&channelId=${this.channelId}&group=G159&t=fx&wx=wx&fxtc=null&payType=110&wx1=wx`
					return
				}
				// 不记名核销特殊处理
				if(this.preOrder && this.productCode) {
				let url = `https://api.dajiuxing.com.cn/djxh5/#/productPurchaseNew?name=Anonymous&subChannelId=${this.subChannelId1}&channelId=${this.channelId}&group=${this.productGroup}&t=fx&test=test&productCode=${this.productCode}&productId=${this.id}`
				if(this.billingId) {
					url += `&billingId=${this.billingId}`
				}
				this.payImg = url
				return
				}
				if(this.channelName == 'thb') return this.payImg=`${SEVERS}djxh5/#/rescueProducts?channelId=${this.channelId}&subChannelId=${this.subChannelId1}&type=1`
				if(this.hebing) return this.payImg=`${SEVERS}djxh5/#/introduceProduct?id=19&productId=19&channelId=${this.channelId}&subChannelId=${this.subChannelId1}&type=1`
        // if(this.channelName == 'thb') return this.payImg=`${SEVERS}djxh5/#/rescueProducts?channelId=${this.channelId}&subChannelId=${this.subChannelId1}&type=1`
				// if(this.hebing) return this.payImg=`https://api.dajiuxing.com.cn/djxh5/#/introduceProduct?name=text&id=19&productId=19&channelId=${this.channelId}&subChannelId=${this.subChannelId1}&type=1`
				var id=''
				if(this.id == 19|| this.id == 21||this.id == 23||this.id == 25||this.id == 27||this.id == 29){
					id=1
				}else if(this.id == 31 || this.id == 33){
					id=2
				}else if(this.id == 11){//经典个人
					id=3
				}else if(this.id == 9){//经典家庭
					id=4
				}else if(this.id == 13){//精英个人
					id=5
				}else if(this.id == 15){//留学
					id=6
				}else if(this.id == 17){//劳务
					id=7
				}else if(this.id == 37){//安心家庭款
					id=8
				}else if(this.id == 35){//尊享家庭款
					id=9
				}
				console.log(this.productCode)
				if(this.productCode) {
				if(this.productGroup=='G262' || this.productGroup=='G258') {
					this.payImg=`https://api.dajiuxing.com.cn/djxh5/#/portList?name=text&subChannelId=${this.subChannelId1}&channelId=${this.channelId}&group=${this.productGroup}&t=fx&test=test&productCode=${this.productCode}`
				}else if(this.productGroup=='G286') {
					this.payImg=`https://api.dajiuxing.com.cn/djxh5/#/Poly?name=text&subChannelId=${this.subChannelId1}&channelId=${this.channelId}&group=${this.productGroup}&t=fx&test=test&productCode=${this.productCode}`
				}else if(this.productGroup=='G310') {
					this.payImg=`https://api.dajiuxing.com.cn/djxh5/#/guanxin?name=text&subChannelId=${this.subChannelId1}&channelId=${this.channelId}&group=${this.productGroup}&t=fx&test=test&productCode=${this.productCode}`
				}else if(this.productGroup=='G377') {
					this.payImg=`https://api.dajiuxing.com.cn/djxh5/#/aoXueTong?name=text&subChannelId=${this.subChannelId1}&channelId=${this.channelId}&group=${this.productGroup}&t=fx&test=test&productCode=${this.productCode}&productId=${this.id}`
				}else {
					this.payImg=`https://api.dajiuxing.com.cn/djxh5/#/productPurchase?name=text&subChannelId=${this.subChannelId1}&channelId=${this.channelId}&group=${this.productGroup}&t=fx&test=test&productCode=${this.productCode}&productId=${this.id}`
				}
				}else {
				if(this.productGroup == null || this.productGroup == '') {
				console.log(1)
				if(SEVERS == "http://api.test.dajiuxing.com.cn/") {
						this.payImg=`https://api.test.dajiuxing.com.cn/djxh5/#/introduceProduct?name=text&subChannelId=${this.subChannelId1}&channelId=${this.channelId}&productId=${this.id}&t=fx&id=${this.id}&test=test`
					}else {
						this.payImg=`https://api.dajiuxing.com.cn/djxh5/#/introduceProduct?name=text&subChannelId=${this.subChannelId1}&channelId=${this.channelId}&productId=${this.id}&t=fx&id=${this.id}`
					}
				//  this.payImg=`${SEVERS}djxh5/#/introduceProduct?id=${this.id}&subChannelId=${this.subChannelId1}&productId=${this.id}&channelId=${this.channelId}&nameType=${this.type}&group=${this.productGroup}`
				}else {
				if(this.productGroup == 'G67') {
					this.payImg=`${SEVERS}djxh5/#/Firstaidkit?subChannelId=${this.subChannelId1}&channelId=${this.channelId}&group=${this.productGroup}&productId=${this.id}&t=fx`
				}else if(this.productGroup == 'G197') {
					this.payImg=`${SEVERS}djxh5/#/nineValenceH5?subChannelId=${this.subChannelId1}&channelId=${this.channelId}&group=${this.productGroup}&productId=${this.id}&t=fx`
				}else if(this.productGroup == 'G204') {
					this.payImg=`https://api.dajiuxing.com.cn/djxh5/#/unblanking?name=text&subChannelId=${this.subChannelId1}&channelId=${this.channelId}&group=${this.productGroup}&productId=${this.id}&t=fx`
				}else if(this.productGroup == 'G203') {
					this.payImg=`https://api.dajiuxing.com.cn/djxh5/#/closestool?name=text&subChannelId=${this.subChannelId1}&channelId=${this.channelId}&group=${this.productGroup}&productId=${this.id}&t=fx`
				}else if(this.productGroup == 'G220') {
					this.payImg=`https://api.dajiuxing.com.cn/djxh5/#/guiZhou?name=text&subChannelId=${this.subChannelId1}&channelId=${this.channelId}&group=${this.productGroup}&productId=${this.id}&t=fx`
				}else {
					if(SEVERS == "http://api.test.dajiuxing.com.cn/") {
						this.payImg=`https://api.test.dajiuxing.com.cn/djxh5/#/introduceProduct?name=text&subChannelId=${this.subChannelId1}&channelId=${this.channelId}&group=${this.productGroup}&t=fx&test=test`
					}else {
						this.payImg=`https://api.dajiuxing.com.cn/djxh5/#/introduceProduct?name=text&subChannelId=${this.subChannelId1}&channelId=${this.channelId}&group=${this.productGroup}&t=fx`
					}
					// this.payImg=`${SEVERS}djxh5/#/introduceProduct?subChannelId=${this.subChannelId1}&channelId=${this.channelId}&group=${this.productGroup}&t=fx`
				} 
				}
				}
				if(this.fxyc == 'fxyc') {
				this.payImg = this.payImg + '&fxyc=fxyc'
				}
			},
			downloadFile(index) { //下载base64图片
				var img = document.getElementById('imgUrl' + index);
				var imgUrl = img.getElementsByTagName("img")[0]
				var fileName = imgUrl.src;
				var base64ToBlob = function(code) {
					let parts = code.split(';base64,');
					let contentType = parts[0].split(':')[1];
					let raw = window.atob(parts[1]);
					let rawLength = raw.length;
					let uInt8Array = new Uint8Array(rawLength);
					for (let i = 0; i < rawLength; ++i) {
						uInt8Array[i] = raw.charCodeAt(i);
					}
					return new Blob([uInt8Array], {
						type: contentType
					});
				};
				let aLink = document.createElement('a');
				let blob = base64ToBlob(fileName); //new Blob([content]);
				let evt = document.createEvent("HTMLEvents");
				evt.initEvent("click", true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
				aLink.download = this.$t('sale.commodity.qrFileName');
				aLink.href = URL.createObjectURL(blob);
				aLink.click();
			}
		},
		components: {
			vueQr
		}
	}
</script>
<style>
	.ewm1 img{display: block;width: 160px;margin: 0 auto;}
</style>
<style scoped="scoped">
	.img img {
		width: 100%;
	}

	.img * {
		text-align: center;
	}

	.img a {
		line-height: 25px;
	}

	.img p {
		margin-top: 10px;
	}

	.select {
		width: 30%;
	}

	.downloadBox {
		text-align: left;
		position: absolute;
		right: 0;
		bottom: 18px;
	}
</style>



// WEBPACK FOOTER //
// src/views/commodity/ewm.vue